<div class="flex align-items-center justify-content-center w-full font-bold border-round m-2 text-3xl title-case">
   System Configuration
</div>
<p-card *ngIf="isDataAvailable">
    <div class="grid">
        <div class="col-12 sm:col-12 md:col-4 lg:col-4">
            <p-panel header="Beam Identification">
                <form [formGroup]="beamForm">
                    <p-table responsiveLayout="scroll" [value]="beamsGridInfo" dataKey="outputOrderNumber"
                    styleClass="p-datatable-gridlines" editMode="row" scrollHeight="250px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="justify-content-center">Beam Id</th>
                            <th class="justify-content-center">Longitude</th>
                            <th class="w-2rem"></th>
                            <th class="w-2rem"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-beam let-editing="editing" let-ri="rowIndex">
                        <tr [pEditableRow]="beam">
                            <td>
                                {{beam.beamId}}
                                <!-- <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" formControlName="beamId" class="w-6rem">                                                                           
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{beam.beamId}}
                                    </ng-template>
                                </p-cellEditor> -->
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" formControlName="satelliteLongitude" required class="w-6rem">
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{beam.satelliteLongitude}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td class="w-2rem">
                                <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow
                                    icon="pi pi-pencil" (click)="onRowEditInit(beam)"
                                    class="p-button-rounded new-btn p-mr-2"></button>
                                <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow
                                    icon="pi pi-check" (click)="onRowEditSave(beam)"
                                    class="p-button-rounded p-button-text p-button-success" [disabled]="!beamForm.valid || beamEnable"></button>
                                <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow
                                    icon="pi pi-times" (click)="onRowEditCancel(beam, ri)"
                                    class="p-button-rounded p-button-text p-button-danger" id="beamcancel"></button>
                            </td>
                            <td class="w-2rem">
                                <button pButton pRipple type="button" icon="pi pi-trash" (click)="onDelete(beam)"
                                    class="p-button-rounded p-button-danger"></button>
                            </td>
                            </tr>
                    </ng-template>
                </p-table>
            </form>                
            <div class="flex justify-content-end flex-wrap mt-3 mr-3">
                <p-button label="Add Beam" (click)="onAddBeam()"></p-button>
            </div>
            </p-panel>
        </div>
        <div class="col-12 sm:col-12 md:col-4 lg:col-4">
            <p-panel header="Service Durations">
             <form [formGroup]="serviceDurationForm">
                <p-table [value]="serviceDurationGridInfo" dataKey="serviceDurationId" editMode="row"
                    responsiveLayout="scroll" styleClass="p-datatable-gridlines" scrollHeight="250px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Duration</th>
                            <th>Unit</th>
                            <th class="w-2rem justify-content-center"></th>
                            <th class="w-2rem justify-content-center"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-duration let-editing="editing" let-ri="rowIndex">
                        <tr [pEditableRow]="duration">
                            <td>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" formControlName="duration" class="w-6rem">
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{duration.duration}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" formControlName="durationUnits" class="w-6rem">
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{duration.durationUnits | titlecase}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td class="w-2rem justify-content-center">
                                <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow
                                    icon="pi pi-pencil" (click)="onDurationRowEditInit(duration)"
                                    class="p-button-rounded"></button>
                                <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow
                                    icon="pi pi-check" (click)="onDurationRowEditSave(duration)" 
                                    class="p-button-rounded p-button-text p-button-success p-mr-2" [disabled]="serviceDurationForm.invalid || serviceDurationEnable"></button>
                                <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow
                                    icon="pi pi-times" (click)="onDurationRowEditCancel(duration, ri)"
                                    class="p-button-rounded p-button-text p-button-danger" id="durationcancel"></button>
                            </td>
                            <td class="w-2rem justify-content-center">
                                <button pButton pRipple type="button" icon="pi pi-trash"
                                    (click)="onDurationDelete(duration)"
                                    class="p-button-rounded p-button-danger"></button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                </form>
                <div class="flex justify-content-end flex-wrap mt-3 mr-3">
                    <p-button label="Add Service Duration" (click)="onAddServiceDuration()"></p-button>
                </div>
            </p-panel>
        </div>
        <div class="col-12 sm:col-12 md:col-4 lg:col-4">
            <p-panel header="Coverage Level Definition">
                <form [formGroup]="coverageLevelForm">
                <p-table [value]="coverageGridInfo" dataKey="coverageLevelId" styleClass="p-datatable-gridlines"
                    editMode="row" scrollHeight="250px" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Coverage Level</th>
                            <th>Number of Beams</th>
                            <th class="w-2rem justify-content-center"></th>
                            <th class="w-2rem justify-content-center"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-coverage let-editing="editing" let-ri="rowIndex">
                        <tr [pEditableRow]="coverage">
                            <td >
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" formControlName="coverageLevel" class="w-8rem">
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{coverage.coverageLevelName}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td >
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" formControlName="noOfBeams" class="w-5rem" (keyup)="onChangeBeams(coverageLevelForm.value.noOfBeams)">
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{coverage.numberOfBeams}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td class="w-2rem justify-content-center">
                                <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow
                                    icon="pi pi-pencil" (click)="onCoverageRowEditInit(coverage)"
                                    class="p-button-rounded"></button>
                                <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow
                                    icon="pi pi-check" (click)="onCoverageRowEditSave(coverage)"
                                    class="p-button-rounded p-button-text p-button-success p-mr-2" [disabled]="coverageLevelForm.invalid || coverageLevEnable || (beamCount < coverageLevelForm.value.noOfBeams)"></button>
                                <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow
                                    icon="pi pi-times" (click)="onCoverageRowEditCancel(coverage, ri)"
                                    class="p-button-rounded p-button-text p-button-danger" id="coveragecancel"></button>
                            </td>
                            <td class="w-2rem justify-content-center">
                                <button pButton pRipple type="button" icon="pi pi-trash"
                                    (click)="onCoverageDelete(coverage)"
                                    class="p-button-rounded p-button-danger"></button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                </form>
                <div class="flex justify-content-end flex-wrap mt-3 mr-3">
                    <p-button label="Add Coverage" (click)="onAddCoverage()"></p-button>
                </div>
            </p-panel>
        </div>        
    </div>

    <div class="grid"> 
        <div class="col-12 sm:col-12 md:col-4 lg:col-4">
            <p-panel header="Receiver Manufacturers">
                <form [formGroup]="rxManufacturerForm">
                <p-table [value]="rxManufacturersGridInfo" dataKey="manufacturerId" editMode="row"
                    styleClass="p-datatable-gridlines" editMode="row" scrollHeight="250px" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Manufacturer Name</th>
                            <th class="w-2rem justify-content-center"></th>
                            <th class="w-2rem justify-content-center"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rxManufacturer let-editing="editing" let-ri="rowIndex">
                        <tr [pEditableRow]="rxManufacturer">
                            <td>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" formControlName="manufactureName">
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{rxManufacturer.manufacturerName}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td class="w-2rem justify-content-center">
                                <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow
                                    icon="pi pi-pencil" (click)="onRxManfRowEditInit(rxManufacturer)"
                                    class="p-button-rounded "></button>
                                <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow
                                    icon="pi pi-check" (click)="onRxManfRowEditSave(rxManufacturer)"
                                    class="p-button-rounded p-button-text p-button-success p-mr-2" [disabled]="rxManufacturerForm.invalid || rxManfuEnable"></button>
                                <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow
                                    icon="pi pi-times" (click)="onRxManfRowEditCancel(rxManufacturer, ri)"
                                    class="p-button-rounded p-button-text p-button-danger" id="rxmanfcancel"></button>
                            </td>
                            <td class="w-2rem justify-content-center">
                                <button pButton pRipple type="button" icon="pi pi-trash"
                                    (click)="onRxManfDelete(rxManufacturer)"
                                    class="p-button-rounded p-button-danger"></button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                </form>
                <div class="flex justify-content-end flex-wrap mt-3 mr-3">
                    <p-button label="Add Manufacturer" (click)="onAddRxManufacturer()"></p-button>
                </div>
            </p-panel>
        </div>
        <div class="col-12 sm:col-12 md:col-8 lg:col-8">
            <p-panel header="Partners">
                <p-table [value]="partnersGridInfo" dataKey="organizationId" styleClass="p-datatable-gridlines"
                    editMode="row" scrollHeight="250px" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Partner ID</th>
                            <th>Partner Name</th>
                            <th>Contact Email</th>
                            <th>Legacy WSDL (Topcon only)</th>
                            <th class="w-2rem justify-content-center"></th>
                            <th class="w-2rem justify-content-center"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-partner let-editing="editing" let-ri="rowIndex">
                        <tr [pEditableRow]="partner">
                            <td >
                                {{partner.partnerId}}
                            </td>
                            <td >
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="partner.organizationDisplayName">
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{partner.organizationDisplayName}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td >
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="partner.email">
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{partner.email}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td >
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="partner.isTopconPartner">
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{partner.isTopconPartner}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td class="w-2rem justify-content-center">
                                <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow
                                    icon="pi pi-pencil" (click)="onPartnerRowEditInit(partner)"
                                    class="p-button-rounded"></button>
                             </td>
                            <td class="w-2rem justify-content-center">
                                <button pButton pRipple type="button" icon="pi pi-trash"
                                    (click)="onPartnerDelete(partner)"
                                    class="p-button-rounded p-button-danger"></button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <div class="flex justify-content-end flex-wrap mt-3 mr-3">
                    <p-button label="Add Partner" (click)="onAddPartner()"></p-button>
                </div>
            </p-panel>
        </div>
    </div>
    <p-panel  header="Customer Support / Test Activation Limit">
        <div class="flex justify-content-center flex-wrap mt-3 mr-6 align-items-start">
            <label class="mr-3">Maximum Test Activation Duration:</label>
            <p-inputNumber [(ngModel)]="testActivationLimit" mode="decimal" inputId="withoutgrouping" [useGrouping]="false"
             class="mr-3 -mt-2" (onInput)="onTestLimitChange($event)" (onBlur)="onFocusOut($event)" [min]="0">
            </p-inputNumber>
            <span class="mr-3">Days</span>
            <p-button class="button-save" label="Save" (onClick)="onSaveTestActivationLimit()" [disabled]="isTestActivationLimitChanged"></p-button>
        </div>
        <div>
            <span class="mt-3 mr-3 error-msg" style="margin-left: 651px;">{{showMessage}}</span>
        </div>

        <div class="flex justify-content-center flex-wrap mt-3 mr-3 align-items-start">
            <label class="mr-3">Maximum Customer Support Activation Duration:</label>
            <p-inputNumber [(ngModel)]="supportActivationLimit" mode="decimal" inputId="withoutgrouping" [useGrouping]="false"
             class="mr-3 -mt-2" (onInput)="onSupportLimitChange($event)" (onBlur)="onFocusOutActivation($event)" [min]="0">
            </p-inputNumber>
            <span class="mr-3">Days</span>
            <p-button label="Save" class="duration-save" (onClick)="onSaveSupportActivationLimit()" [disabled]="issupportActivationLimitChanged"></p-button>
        </div>
        <div>
            <span class="mt-3 mr-3 error-msg" style="margin-left: 651px;">{{showErrorMessage}}</span>
        </div>
    </p-panel>
    
    <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" [ngClass]="{'errorcode':errorResponseCode}">
    </p-confirmDialog>
    <form [formGroup]="addNewDetailsForm">
    <p-dialog [(visible)]="onAddItems" [style]="{width: '30vw'}" [draggable]="false" [resizable]="false"
        (onHide)="onModalDialogHide()" header="{{onAddDialogHeader}}" appendTo="body" [modal]="true">
        <div *ngIf="onAddDialogHeader === 'Add New Beam'">
            <div class="grid">
                <div class="col-12 md:col-4" style="text-align: right;">
                    <label class="required-field label">Beam Id : </label>
                </div>
                <div class="col-12 md:col-4">
                    <input type="text" pInputText formControlName="newBeam">
                    <div *ngIf="!addNewDetailsForm.controls['newBeam'].valid && addNewDetailsForm.controls['newBeam'].dirty"
                        class="error-msg">
                        <span *ngIf="addNewDetailsForm.controls['newBeam']?.hasError('required')">
                            Beam is required</span>
                        <span *ngIf="addNewDetailsForm.controls['newBeam']?.hasError('pattern')">
                            Beam should be alphanumeric</span>
                    </div>
                </div>
            </div>
            <div class="grid">
                <div class="col-12 md:col-4" style="text-align: right;">
                    <label class="required-field label">Longitude : </label>
                </div>
                <div class="col-12 md:col-4">
                    <input type="text" pInputText formControlName="newLongitude">
                    <div *ngIf="!addNewDetailsForm.controls['newLongitude'].valid && addNewDetailsForm.controls['newLongitude'].dirty"
                        class="error-msg">
                        <span *ngIf="addNewDetailsForm.controls['newLongitude']?.hasError('required')">
                            Longitude is required</span>
                        <span *ngIf="addNewDetailsForm.controls['newLongitude']?.hasError('min')">
                            Longitude should have -180 as minimum</span>
                        <span *ngIf="addNewDetailsForm.controls['newLongitude']?.hasError('max')">
                            Longitude should have 180 as maximum</span>
                        <span *ngIf="addNewDetailsForm.controls['newLongitude']?.hasError('pattern')">
                            Longitude should be in the range -180 to 180 and should contain only 1 decimal point</span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="onAddDialogHeader === 'Add Coverage Level'">
            <div class="grid">
                <div class="col-12 md:col-6" style="text-align: right;">
                    <label class="required-field label">Coverage Level : </label>
                </div>
                <div class="col-12 md:col-6">
                    <input type="text" pInputText formControlName="newCoverageLevel">
                    <div *ngIf="!addNewDetailsForm.controls['newCoverageLevel'].valid && addNewDetailsForm.controls['newCoverageLevel'].dirty"
                        class="error-msg">
                        <span *ngIf="addNewDetailsForm.controls['newCoverageLevel']?.hasError('required')">
                            Coverage is required</span>
                        <span *ngIf="addNewDetailsForm.controls['newCoverageLevel']?.hasError('pattern')">
                            Coverage should be characters only</span>
                    </div>
                </div>
            </div>
            <div class="grid">
                <div class="col-12 md:col-6" style="text-align: right;">
                    <label class="required-field label">Number Of Beams : </label>
                </div>
                <div class="col-12 md:col-6">
                    <input type="type" pInputText formControlName="newNoOfBeams">
                    <div *ngIf="!addNewDetailsForm.controls['newNoOfBeams'].valid && addNewDetailsForm.controls['newNoOfBeams'].dirty"
                        class="error-msg">
                        <span *ngIf="addNewDetailsForm.controls['newNoOfBeams']?.hasError('required')">
                            NO. of Beams are required</span>
                        <span *ngIf="addNewDetailsForm.controls['newNoOfBeams']?.hasError('pattern')">
                            NO. of Beams should be numeric only</span>
                        <!-- <span *ngIf="addNewDetailsForm.controls['newNoOfBeams']?.hasError('max') && !addNewDetailsForm.controls['newNoOfBeams']?.hasError('pattern')">
                                Maximum no. of Beams should be less than or equal to 9</span> -->
                        <span *ngIf="addNewDetailsForm.controls['newNoOfBeams']?.hasError('min') && !addNewDetailsForm.controls['newNoOfBeams']?.hasError('pattern')">
                                    Minimum no. of Beams should be greater than 0</span>
                    </div>
                    <div class="error-msg font-size-msg" *ngIf="(beamCount < addNewDetailsForm.value.newNoOfBeams) && (!addNewDetailsForm.controls['newNoOfBeams']?.hasError('pattern'))">
                        No. of Beams should not be greater than {{ beamCount}}</div>
                </div>
            </div>
        </div>
        <div *ngIf="onAddDialogHeader === 'Add Service Duration'">
            <div class="grid">
                <div class="col-12 md:col-6" style="text-align: right;">
                    <label class="required-field label">Duration : </label>
                </div>
                <div class="col-12 md:col-6">
                    <input type="text" pInputText formControlName="newDuration">
                    <div *ngIf="!addNewDetailsForm.controls['newDuration'].valid && addNewDetailsForm.controls['newDuration'].dirty"
                        class="error-msg">
                        <span *ngIf="addNewDetailsForm.controls['newDuration']?.hasError('required')">
                            Duration is required</span>
                        <span *ngIf="addNewDetailsForm.controls['newDuration']?.hasError('pattern')">
                            Duration be numeric only</span>
                    </div>
                </div>
            </div>
            <div class="grid">
                <div class="col-12 md:col-6" style="text-align: right;">
                    <label class="required-field label">Duration Units : </label>
                </div>
                <div class="col-12 md:col-6">
                    <input type="type" pInputText formControlName="newDurationUnits">
                    <div *ngIf="!addNewDetailsForm.controls['newDurationUnits'].valid && addNewDetailsForm.controls['newDurationUnits'].dirty"
                        class="error-msg">
                        <span *ngIf="addNewDetailsForm.controls['newDurationUnits']?.hasError('required')">
                            Duration Units are required</span>
                        <span *ngIf="addNewDetailsForm.controls['newDurationUnits']?.hasError('pattern')">
                            Duration Units should be characters only</span>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="onAddDialogHeader === 'Add Manufacturer'">
            <div class="grid">
                <div class="col-12 md:col-4" style="text-align: right;">
                    <label class="required-field label">Manufacturer : </label>
                </div>
                <div class="col-12 md:col-4">
                    <input type="text" pInputText formControlName="newManufactureName">
                    <div *ngIf="!addNewDetailsForm.controls['newManufactureName'].valid && addNewDetailsForm.controls['newManufactureName'].dirty"
                        class="error-msg">
                        <span *ngIf="addNewDetailsForm.controls['newManufactureName']?.hasError('required')">
                            Manufacturer is required</span>
                        <span *ngIf="addNewDetailsForm.controls['newManufactureName']?.hasError('pattern')">
                            Manufacturer should be alphanumeric</span>
                    </div>
                </div>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <button pButton label="Cancel" (click)="onCancel($event)" class="p-button-danger"></button>
            <button pButton (click)="onAddItem()" label="Add" [disabled]="disableAddItems()"></button>
        </ng-template>
    </p-dialog>  
    </form>  
</p-card>
<p-toast styleClass="custom-toast" life="10000" position="top-center"></p-toast>
<!-- <div class="loading-indicator" *ngIf="loading">
    <div style="width: 250px;margin-top: -150px;margin-left: -65px;">
      <span style="position: relative;text-align: center;color: #176D94;font-size: 24px;">{{spnieerMsg}}</span>
    </div>
    <p-progressSpinner ></p-progressSpinner>
</div> -->